import { EditionAwarenessContextType } from './edition-awareness-context';

export const isEligibleForAutomationLimits = ({
	edition,
	product,
	automationUsage = 0,
	lastAutomationFreeLimitBreachDate = null,
	isInTrial,
}: EditionAwarenessContextType) => {
	if ((edition === 'free' || (edition === 'standard' && isInTrial)) && product === 'jira') {
		if (hasAutomationBreached(automationUsage)) {
			return 'breached';
		}
		if (isAutomationProjectedToBreach(automationUsage)) {
			return 'projectedToBreach';
		}
		if (hasBreachedAutomationUsagePreviousMonth(lastAutomationFreeLimitBreachDate)) {
			return 'breachedPreviousMonth';
		}
		return false;
	}
	return false;
};

/** This calculates the projected automation usage **/
export const projectedAutomationUsage = (automationUsage = 0) => {
	const today = new Date();
	const dayOfMonth = today.getDate();
	const daysInThisMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
	return (automationUsage / dayOfMonth) * daysInThisMonth;
};

export const isAutomationProjectedToBreach = (automationUsage = 0) => {
	const AUTOMATION_USAGE_FREE_LIMIT = 100;
	const PROJECTED_USAGE_WARNING_THRESHOLD = 0.8 * AUTOMATION_USAGE_FREE_LIMIT;
	const projectedUsage = projectedAutomationUsage(automationUsage);

	return (
		projectedUsage >= AUTOMATION_USAGE_FREE_LIMIT &&
		automationUsage > PROJECTED_USAGE_WARNING_THRESHOLD
	);
};

export const hasAutomationBreached = (automationUsage = 0) => {
	const AUTOMATION_USAGE_FREE_LIMIT = 100;
	return automationUsage >= AUTOMATION_USAGE_FREE_LIMIT;
};

export const hasBreachedAutomationUsagePreviousMonth = (
	lastAutomationFreeLimitBreachDate: Date | null,
) => {
	if (
		!lastAutomationFreeLimitBreachDate ||
		isNaN(new Date(lastAutomationFreeLimitBreachDate).getTime())
	) {
		return false;
	}
	const now = new Date();
	const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
	const checkPreviousMonth = new Date(lastAutomationFreeLimitBreachDate);
	return (
		checkPreviousMonth.getFullYear() === lastMonth.getFullYear() &&
		checkPreviousMonth.getMonth() === lastMonth.getMonth()
	);
};
